/**
 * This function rounds a given time to the nearest quarter hour and returns the rounded time in ISO string format.
 *@param {Date} time - The time to round to the nearest quarter hour
 *@returns {Date} - The rounded time in ISO string format
 */
export function roundTimeQuarterHour(time) {
	if (!time) return;
	var timeToReturn = new Date(time);

	timeToReturn.setMilliseconds(Math.ceil(timeToReturn.getMilliseconds() / 1000) * 1000);
	timeToReturn.setSeconds(Math.ceil(timeToReturn.getSeconds() / 60) * 60);
	timeToReturn.setMinutes(Math.ceil(timeToReturn.getMinutes() / 15) * 15);
	return timeToReturn.toISOString();
}
